import { useNavigate } from '@tanstack/react-router';

import { useEstimationQueryActions } from '@/api/hooks/estimationQueryActions';
import CheckCircleIcon from '@/assets/check-circle-icon.svg?react';
import { Button } from '@/components/atoms/Button';
import { useMessages } from '@/hooks/messages';

import { eEstimationDetailTab } from '../model';
import { estimationApproveButtonMessageDefinitions } from './messages';

interface ApproveButtonProps {
  estimationId: string;
}

export const ApproveButton: FC<ApproveButtonProps> = ({ estimationId }) => {
  const messages = useMessages(estimationApproveButtonMessageDefinitions);
  const navigate = useNavigate();

  const { useApproveEstimation } = useEstimationQueryActions();
  const estimationApprovalMutation = useApproveEstimation();

  return (
    <Button
      data-testid='approve-button'
      variant='primary'
      IconComponentLeft={CheckCircleIcon}
      onClick={async () => {
        await estimationApprovalMutation.mutateAsync({ estimationId });
        await navigate({
          to: '/estimation/detail/$estimationId/$tabId',
          params: { estimationId, tabId: eEstimationDetailTab.review },
        });
      }}
    >
      {messages.cancelReviewButton()}
    </Button>
  );
};
